import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import { Box, Tab, Tabs } from "@material-ui/core";



const useStyles = makeStyles(theme => ({
    tabBox: {
        '& .MuiTabs-root':{
            minHeight: 40,
        },
        '& .MuiTab-root':{
            minWidth: 70,
        },
        '& .MuiTabs-flexContainer': {
            // width: 248,
            borderBottom: '1px solid #bbbbbb',
            borderRadius: 0,
            overflow: 'hidden'
        },
        '& button': {
            width: 70,
            minHeight: 40,
            height: 40,
            position: 'relative',
            fontSize: '1.063rem',
            fontWeight: 500,
            letterSpacing: '-0.5px',
            color:'#323232',
            boxSizing: 'border-box',
            padding:0,
        },
        '& button.Mui-selected': {
            fontWeight: 600,
            color: '#5579f0',
            opacity: 1,
            boxSizing: 'border-box',
            background: '#fff',
            borderRadius: 0
        },
        '& .MuiTabs-indicator':{
            height: 3,
            paddingBottom: 0,
            backgroundColor: '#5579f0'
        }
    }
}));

function EduLangTabs(props) {
    const {value, handleChange} = props;
    const classes = useStyles();

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }


    return (
        <Box position="static" className={classes.tabBox}>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label="한국어" {...a11yProps(0)} disableRipple/>
                <Tab label="영어" {...a11yProps(1)} disableRipple/>
                <Tab label="일본어" {...a11yProps(2)} disableRipple/>
                <Tab label="중국어" {...a11yProps(3)} disableRipple/>
            </Tabs>
        </Box>
    );
}

export default EduLangTabs;
